export function getRecordingPlaybackUrl(recordingUrl) {
  if (!recordingUrl) return null;

  // Use API URL as-is (engine.tellyflow.com or client.tellyflow.com)
  if (recordingUrl.includes('/v1/api/recordings/')) {
    return recordingUrl;
  }

  // Raw Vapi storage — proxy via engine (works for all clients)
  if (recordingUrl.startsWith('https://storage.vapi.ai/')) {
    const path = recordingUrl.replace('https://storage.vapi.ai/', '');
    return `https://engine.tellyflow.com/v1/api/recordings/${path}`;
  }

  return recordingUrl;
}
